import { render, staticRenderFns } from "./QuotationPricing.vue?vue&type=template&id=64ccbc69&scoped=true&"
import script from "./QuotationPricing.vue?vue&type=script&lang=js&"
export * from "./QuotationPricing.vue?vue&type=script&lang=js&"
import style0 from "./QuotationPricing.vue?vue&type=style&index=0&id=64ccbc69&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ccbc69",
  null
  
)

export default component.exports